'use client';
import {ButtonBase, Popover, SvgIcon} from '@mui/material';
import {FC, ReactNode, useEffect, useRef} from 'react';
import {SxProps, Theme} from '@mui/material/styles';
import MuiTypography from '../../atoms/MuiTypography';
import MuiBox from '../../atoms/MuiBox';
import {useToggle} from '@hooks/useToogle';

interface FilterPopupProps {
  children: ReactNode;
  sx?: Record<'trigger' | 'popup', SxProps<Theme>>;
  label: string;
  value: string;
  onToggle?: () => void;
  open?: boolean;
}
export const FilterPopup: FC<FilterPopupProps> = (props) => {
  const triggerElement = useRef<HTMLButtonElement>(null);
  const [open, toggle] = useToggle(props.open || false);
  const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    toggle();
    if (props.onToggle) props.onToggle();
  };

  useEffect(() => {
    toggle(props.open || false);
  }, [props.open]);

  return (
    <>
      <ButtonBase
        ref={triggerElement}
        onClick={handleToggle}
        disableRipple
        sx={{
          display: 'flex',
          gap: '2px',
          height: '100%',
          flexDirection: 'column',
          maxWidth:'109px',
          minWidth: '109px',
          alignItems: 'flex-start',
          paddingInline: '12px',
          ...props.sx?.trigger,
        }}>
        <MuiTypography
          sx={{
            fontSize: '13px',
            fontWeight: 500,
            lineHeight: '16.25px',
            color: 'rgba(45, 45, 45, 1)',
            opacity: 0.6,
          }}>
          {props.label}
        </MuiTypography>
        <MuiBox
          sx={{
            display: 'flex',
            gap: '2px',
            width: '100%',
            alignItems: 'center',
          }}>
          <MuiTypography
            title={props.value}
            sx={{
              fontSize: '17px',
              fontWeight: 500,
              lineHeight: '23.8px',
              letterSpacing: '-0.4px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}>
            {props.value}
          </MuiTypography>
          <SvgIcon sx={{width: '10px', height: '6px'}}>
            <svg
              width='10'
              height='6'
              viewBox='0 0 10 6'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M1 1L4.29289 4.29289C4.62623 4.62623 4.79289 4.79289 5 4.79289C5.20711 4.79289 5.37377 4.62623 5.70711 4.29289L9 1'
                stroke='#2D2D2D'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </SvgIcon>
        </MuiBox>
      </ButtonBase>
      <Popover
        open={open}
        onClose={handleToggle}
        anchorEl={triggerElement.current}
        disableScrollLock
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={
          
          {
            ...props.sx?.popup,
            '& .MuiPopover-paper': {
              marginTop: '18px',
              borderRadius: '24px',
              padding: '24px',
              boxShadow: '0px 8px 16px 0px #00000014',
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '464px',
              width: '464px',
              ...(props.sx?.popup && (props.sx.popup as any)['& .MuiPopover-paper'])
            },
        }}>
        {props.children}
      </Popover>
    </>
  );
};
